/* Weekly banner schedule in Amsterdam time, including daylight-saving changes. */
(function () {
  const formatter = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/Amsterdam', year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
  });
  function wallTime(timestamp) {
    const parts = Object.fromEntries(formatter.formatToParts(new Date(timestamp)).map(p => [p.type, p.value]));
    return Date.UTC(+parts.year, +parts.month - 1, +parts.day, +parts.hour, +parts.minute, +parts.second);
  }
  function toInstant(wall) {
    let instant = wall;
    for (let i = 0; i < 3; i++) instant += wall - wallTime(instant);
    return instant;
  }
  function weeklyState(now = Date.now()) {
    const wall = new Date(wallTime(now));
    const day = wall.getUTCDay();
    const active = !(day === 1 && wall.getUTCHours() < 15);
    const daysToMonday = ((8 - day) % 7) || 7;
    const end = toInstant(Date.UTC(wall.getUTCFullYear(), wall.getUTCMonth(), wall.getUTCDate() + daysToMonday));
    return { active, end, seconds: active ? Math.max(0, Math.ceil((end - now) / 1000)) : 0 };
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { weeklyState };
  if (typeof document === 'undefined') return;

  function update() {
    const state = weeklyState();
    const values = [Math.floor(state.seconds / 86400), Math.floor(state.seconds / 3600) % 24, Math.floor(state.seconds / 60) % 60, state.seconds % 60];
    const updateDigits = (container) => container.querySelectorAll('[data-weekly-digit]').forEach((el, i) => {
      const value = String(values[i]).padStart(2, '0');
      if (el.textContent !== value) el.textContent = value;
    });
    document.querySelectorAll('[data-weekly-banner]').forEach(banner => {
      const deal = banner.querySelector('[data-weekly-active]');
      const fallback = banner.querySelector('[data-weekly-fallback]');
      deal.hidden = !state.active;
      fallback.hidden = state.active;
      if (!state.active) return;
      updateDigits(banner);
    });
    document.querySelectorAll('[data-weekly-compact]').forEach(timer => {
      timer.hidden = !state.active;
      if (state.active) updateDigits(timer);
    });
  }
  update();
  window.setInterval(update, 1000);
  document.addEventListener('visibilitychange', update);
  window.addEventListener('pageshow', update);
  document.addEventListener('shopify:section:load', update);
})();
